export default "__VITE_ASSET__05f664fd__"